import script from "./PaymentHomePage.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentHomePage.vue?vue&type=script&setup=true&lang=js"

import "./PaymentHomePage.vue?vue&type=style&index=0&id=ef664a70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef664a70"]])

export default __exports__